import { Injectable } from '@angular/core';
import { IIDolCommunicationStore } from './iidOlCommunication.store';
import { IID_OL_COMMUNICATION } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDolCommunicationQuery } from './iidOlCommunication.query'
import { CrudService } from '../crudService';
import { IssueEntityStoreStrategy } from '../updateStoreStrategies';
import { WsACKCallback } from '@common/api/ack';
import { PartialUpdate } from '@common/interfaces/base';

const TOPIC = Topics.IID_OL_COMMUNICATION;
@Injectable({
  providedIn: 'root'
})
export class IIDolCommunicationService extends CrudService<IID_OL_COMMUNICATION, IIDolCommunicationStore, IIDolCommunicationQuery> {
  constructor(
    protected store: IIDolCommunicationStore,
    protected query: IIDolCommunicationQuery,
    protected actionService: ActionService,
    protected updateStrategy: IssueEntityStoreStrategy,
  ) {
    super(
      TOPIC,
      store,
      query,
      actionService,
      updateStrategy
    );
  }

  create(payload: IID_OL_COMMUNICATION): void {
    
  }

  update(data: PartialUpdate<IID_OL_COMMUNICATION>, callback?: WsACKCallback): void {
    
  }

  retry(id: string) {
    this.actionService.sendMessage(TOPIC, 'retry', {id})
  }

  

}
